export enum WebFormSettingsTypes {
    SET_WEBFORM_CONFIGS = 'SET_WEBFORM_CONFIGS',
    SET_WEBFORM_CONFIGS_LOADING = 'SET_WEBFORM_CONFIGS_LOADING',
}

export interface IWebFormConfig {
    ID: string;
    webformName: string;
    businessEmail: string;
    webformDescription: string;
    brand: string;
    customAttributes?: Record<string, string>;
    maxAttachmentSize: number;
    allowedAttachmentTypes: string[];
    virusScanEnabled: boolean;
}

export interface IWebformConfigUpdateData {
    businessEmail?: string;
    webformDescription?: string | null;
    customAttributes?: Record<string, string> | null;
    virusScanEnabled: boolean;
}
